<div class="tw-overflow-hidden tw-mb-3 tw-rounded-t-[18px] tw-w-[120px] tw-h-[150px] tw-flex tw-items-center tw-justify-center tw-bg-gray-100"
     [class]="{'tw-mb-3': !isShopRevampExperimentOn, 'tw-mb-2': isShopRevampExperimentOn}"
     (click)="gotoProduct.emit(product())">
    <img class="tw-max-h-full tw-max-w-full"
         alt="{{ productTitle() }}"
         #image=""
         [src]="productImage()" />
</div>
<h2 class="tw-flex-1 tw-font-lexend tw-font-medium tw-text-200 tw-mb-0.5 tw-w-[90%] tw-line-clamp-3"
    (click)="gotoProduct.emit(product())">
    {{ productTitle() }}
</h2>
@if (isShopRevampExperimentOn) {
    <div class="tw-mb-3 tw-flex tw-items-center tw-gap-1 tw-font-lexend"
         (click)="gotoProduct.emit(product())">
        <p class="tw-font-medium tw-text-200 tw-text-gray-500 tw-line-through">
            ₹{{ product()?.mrp }}
        </p>
        <p class="tw-font-bold tw-text-300 tw-text-orange-500">
            ₹{{ product()?.price }}
        </p>
    </div>
} @else {
    <div class="tw-flex tw-gap-2 tw-mb-3 tw-font-lexend"
         (click)="gotoProduct.emit(product())">
        <p class="tw-font-bold tw-text-300 tw-line-through">
            ₹{{ product()?.mrp }}
        </p>
        <p class="tw-font-bold tw-text-300 tw-text-orange-500">
            ₹{{ product()?.price }}
        </p>
    </div>
}


@if (productQuantity() === 0) {
    <button csButton
            size="small"
            (click)="addToCart.emit({ product: product(), image })"
            class="tw-min-w-fit tw-w-fit tw-px-[26px]"
            style="margin: 0 !important;">
        <span class="tw-text-300"
              i18n="@@add">Add</span>
    </button>
} @else {
    <div class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-w-fit tw-items-center tw-text-300 tw-bg-white tw-text-teal-600 tw-font-lexend tw-font-semibold swiper-no-swiping">
        <div class="tw-px-[11.5px] tw-flex">
            <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'" (click)="reomveFromCart.emit(product())"></cs-icon>
        </div>
        <span class="tw-px-1">{{ productQuantity() }}</span>
        <div class="tw-px-[11.5px] tw-flex">
            <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'" (click)="addToCart.emit({ product: product(), image })"></cs-icon>
        </div>
    </div>
}